<template>
  <div
    class="bottom-0 w-full md:absolute md:left-0 md:top-0 md:flex md:flex-col md:h-full md:justify-center md:w-auto"
    :class="{'absolute': roundedTop}"
  >
    <div
      class="bottom-0 z-20 flex flex-row justify-center justify-between w-full h-12 overflow-hidden bg-green-400 md:absolute md:bottom-0 md:flex-col md:bottom-auto md:w-12 md:rounded-t-none md:rounded-r-lg md:h-220 sm:right-3 md:right-auto transition-all duration-200 ease-out"
      @click.prevent
      :class="{'md:w-220 h-40 md:h-220 grow': isOpen, 'absolute sm:w-220 rounded-t-lg': roundedTop}"
    >
      <div
        class="flex flex-row items-center justify-center h-full p-3"
        :class="{'h-full flex-col text-center w-full items-center -mr-10 fadein': isOpen, 'flex-row md:flex-col': !isOpen}"
      >
        <div class="flex flex-col justify-center">
          <img
            :src="image || 'https://cdn.sportsrecruits.com/assets/itg/c-block-letter.svg'"
            class="bg-white rounded-full"
            :class="{'h-12 w-12 mt-1 mb-3 p-1': isOpen, 'p2px h-6 w-6 mr-2 md:mr-0 md:mb-2 md:rotate-90 fadein': !isOpen}"
          />
        </div>
        <div class="flex flex-col justify-center" :class="{'fadein': !isOpen}">
          <img
            src="https://cdn.sportsrecruits.com/assets/itg/committed-white-wordmark.svg"
            class="h-4"
            :class="{'mb-2': isOpen, 'md:rotate-90 image-rotate': !isOpen}"
          />
        </div>
        <div :class="{'hidden': !isOpen}">
          <p class="mb-1 antialiased font-medium text-white ds-text-sm">{{name}}</p>
        </div>
      </div>
      <div
        class="flex flex-col p-2 cursor-pointer"
        @click.prevent="toggle"
        v-if="name"
        :class="{'bg-green-100 justify-center fadein': !isOpen, 'md:items-end': isOpen}"
      >
        <i
          class="ds-text-2xl sr-2 sr-v2-chevron"
          :class="{'rotate-180 md:rotate-270 text-green-400': !isOpen, 'text-white md:rotate-90': isOpen}"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: { required: false, type: String, default: null },
    name: { required: false, type: String, default: null },
    roundedTop: { required: false, type: Boolean, default: true }
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="scss" scoped>
.flip {
  transform: rotate(180deg);
}

.p2px {
  padding: 2px;
}

@media only screen and (min-width: 768px) {
  .image-rotate {
    margin: calc((110px - 18px) / 2) calc((18px - 110px) / 2);
  }

  .md\:w-220 {
    width: 220px !important;
  }

  .md\:h-220 {
    height: 220px !important;
  }
}

@media only screen and (min-width: 640px) and (max-width: 767px) {
  .sm\:w-220 {
    width: 220px !important;
  }
}

@keyframes fadein {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.fadein {
  animation: fadein 0.5s;
}
</style>